(ns app.front.view.meeting.meeting-events
  (:require [app.front.ui.unsaved-changes :as unsaved-changes]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(defn- get-timestamp [js-date [hours minutes]]
  (when (and (some? js-date)
             (integer? hours)
             (integer? minutes))
    (doto (js/Date. js-date)
      (.setHours hours)
      (.setMinutes minutes))))


(defn- update-backend-datetime-fields
  "Backend uses two instants for the meeting start and end time.
  The frontend uses separate pickers for the date and the times."
  [{:keys [date start end] :as meeting}]
  (-> meeting
      (dissoc :meeting/start :meeting/end)
      (p/assoc-if :date date :start start :end end)
      (p/assoc-if :meeting/start (get-timestamp date start))
      (p/assoc-if :meeting/end (get-timestamp date end))))


(rf/reg-event-db
  ::toggle-expanded
  (fn [db [_ meeting-id]]
    (update-in db [::meetings meeting-id :expanded?] not)))


(rf/reg-event-db
  ::expand-created-draft
  (fn [db [_ _ entity-updates]]
    (if-let [meeting-id (some (fn [[entity-id {[_ entity-state] :domain/state}]]
                                (when (= :meeting.state/draft entity-state)
                                  entity-id))
                              entity-updates)]
      (assoc-in db [::meetings meeting-id :expanded?] true)
      db)))


(rf/reg-event-fx
  ::create-draft
  (fn [_ [_ parent-id]]
    {:dispatch [:app.front.process/signal
                parent-id
                [:process.signal/create-meeting-draft {:parent-id parent-id}]
                {:on-success [::expand-created-draft]}]}))


(rf/reg-event-fx
  ::cancel-changes
  (fn [_ [_ unsaved-field-ids]]
    {:dispatch [::unsaved-changes/remove-unsaved-values unsaved-field-ids]}))


(rf/reg-event-fx
  ::save-changes
  (fn [_ [_ parent-id meeting unsaved-field-ids]]
    (let [params (-> meeting
                     update-backend-datetime-fields
                     (select-keys [:meeting/topic :meeting/notes :meeting/start :meeting/end])
                     (assoc :meeting-id (:db/id meeting)))]
      {:dispatch [:app.front.process/signal
                  parent-id
                  [:process.signal/edit-meeting params]
                  {:on-success [::cancel-changes unsaved-field-ids]
                   :notify     {:success :changes-saved}}]})))


(rf/reg-event-fx
  ::publish
  (fn [_ [_ parent-id meeting-id]]
    {:dispatch [:app.front.process/signal
                parent-id
                [:process.signal/publish-meeting {:meeting-id meeting-id}]
                {:notify {:success :changes-saved}}]}))


(rf/reg-event-fx
  ::cancel-meeting
  (fn [_ [_ parent-id meeting-id]]
    {:dispatch [:app.front.process/signal
                parent-id
                [:process.signal/cancel-meeting {:meeting-id meeting-id}]
                {:notify {:success :meeting/meeting-canceled}}]}))


(rf/reg-event-fx
  ::mark-as-held
  (fn [_ [_ parent-id meeting-id]]
    {:dispatch [:app.front.process/signal
                parent-id
                [:process.signal/mark-meeting-as-held {:meeting-id meeting-id}]
                {:notify {:success :changes-saved}}]}))
